<template>
  <div class="row" style="padding-top: 0;">
    <div class="contents_area contact_container center_center">
      <div class="text_center">
        <h4 class="--white mb15">Contact rebless team</h4>
        <p class="txt_body_1 --white">
          Contact us for all support requests.<br>
          Please do not hesitate to contact me if you have any queires.
        </p>

        <div class="mt60 center_center" style="height: 40px">
          <a :href="`mailto:${this.mail}`"
              class="btn white btn_basics btn_fit pointer no-drag"
          >
            Contact rebless team
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {_SERVICE_MAIL} from "@/static";
export default {
  name: 'Contact',
  data() {
    return {
      mail: _SERVICE_MAIL
    }
  },
  methods: {

  }
}
</script>